<template>
    <div>
        <div style="margin-bottom: 20px;margin-top: 10px">
            <router-view></router-view>
            <el-button size="small" type="success" icon="el-icon-plus" v-if="!isAuditViewOnly" @click="handleAdd()">预付款转移</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="changeTab">
            <el-tab-pane name="in" label="转移合同-入账"></el-tab-pane>
            <el-tab-pane name="out" label="转移合同-扣款"></el-tab-pane>
        </el-tabs>
        <w-table ref="wMyTable" :columns="columns" :table-data="tableData"
            @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page"
            @pageChange="handlePagePagination">
            <div slot="operation" slot-scope="{text,record}">
                <el-button size="mini" v-if="record.contractFilePath" type="primary"
                    @click="download(record)">下载附件</el-button>
            </div>
            <div slot="contractNumber" slot-scope="{text,record,index,column}">
                <span>{{ text }}</span>
                <el-tooltip content="复制">
                    <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
                </el-tooltip>
            </div>
            <div slot="contractName" slot-scope="{text,record,index,column}">
                <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
            </div>
            <div slot="contractType" slot-scope="{text,record}">
                <div class="status-tag-container">
                    <el-tag :type="getContractColor(text, 'tagType')" :style="{
                        color: getContractColor(text, 'color'),
                        'background-color': getContractColor(text, 'backgroundColor'),
                        'border-color': getContractColor(text, 'borderColor')
                    }">{{
                        getContractColor(text, 'name') }}</el-tag>
                </div>
            </div>
        </w-table>
        <picture-loading v-if="loading"></picture-loading>
        <create-transfer v-if="showAddTransfer" :show-dialog="showAddTransfer" @submit="closeAdd"></create-transfer>
    </div>
</template>

<script>

import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import { transferContractOut } from "@/utils/data/tableCol/contract/transferContractOut";
import { transferContractIn } from "@/utils/data/tableCol/contract/transferContractIn";
import { attachmentContract, getContractPage } from "@/api/dilivery/sales/contract"
import { copyText } from "@/utils/windowsUtils";
import CreateTransfer from "@/views/systems/Contract/CreateTransfer.vue"
import { getContractColor } from "@/color"
import { viewDetailIcon } from "@/utils/icon";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { auditViewOnlyMixin } from "@/mixins/auditViewOnlyMixin";
const baseURL = process.env.VUE_APP_BASE_API

export default {
    name: "TransferContract",
    components: { PictureLoading, CreateTransfer },
    mixins: [auditViewOnlyMixin],
    data() {
        return {
            loading: false,
            tableData: [],
            page: {
                currentNum: 1,
                pageSize: 10,
                total: 0
            },
            sortConditionTag: [],
            searchConditionTag: [],
            activeName: 'in',
            showAddTransfer: false,
            viewDetailIcon: viewDetailIcon,
        }
    },
    computed: {
        columns() {
          if(this.activeName === 'in'){
            return JSON.parse(JSON.stringify(transferContractIn([] || {})))
          }else {
            return JSON.parse(JSON.stringify(transferContractOut([] || {})))
          }
        },
    },
    watch: {

    },
    mounted() {
        this.getData()
    },
    methods: {
        async download(row) {
            try {
                let url = `${baseURL}/sequencing-contract/attachment/${row.id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        getContractColor,
        getData(type) {
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
            };
            if (type) {
                params['page.current'] = 1;
                params['page.size'] = 10;
            }
            if (this.sortConditionTag.length > 0) {
                params["order"] = this.sortConditionTag.map(sortCondition => {
                    return sortCondition.colName + "." + sortCondition.order;
                }).join(",");
            }
            let sendData = { "query#contractType.EQ": "ADVANCE_PAYMENT_TRANSFER" };
            switch (this.activeName) {
                case 'in':
                    sendData["query#projectType.EQ"] = "转移合同入账"
                    break
                case 'out':
                    sendData["query#projectType.EQ"] = "转移合同扣款"
                    break;
                default:
                    break
            }
            sendData = this.getSearch(sendData);
            getContractPage(params, sendData).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data.records
                    this.page.currentNum = parseInt(res.data.current);
                    this.page.pageSize = parseInt(res.data.size);
                    this.page.total = parseInt(res.data.total);
                }
            }).catch(error => {
                this.loading = false
             });
        },
        getSearch(sendData, index) {
            let data = ['customerContactsName', 'salesName']
            this.searchConditionTag.forEach(item => {
                let value = item.value
                if (['contractNumber'].includes(item.key)) {
                    value = value.replace(/[A-Za-z]/g, "")
                }
                if (data.includes(item.key)) {
                    sendData[item.key] = value
                } else {
                    sendData["query#" + item.key + ".LIKE"] = value
                }

            })
            return sendData
        },
        //获取表格搜索条件
        getTableSearchSortCon(searchConditionTag, sortConditionTag) {
            this.searchConditionTag = searchConditionTag
            this.sortConditionTag = sortConditionTag
            this.getData(true)
        },
        //分页
        handlePagePagination(page) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData()
        },
        changeTab(tab, event) {
            if (this.activeName !== 'create') {
                this.getData(true)
            }
        },

        // 复制
        copyData(text) {
            copyText(text)
            this.$messageUi.success('复制成功')
        },
        handleAdd() {
            this.showAddTransfer = true
        },
        closeAdd(type) {
            this.showAddTransfer = false
            if (type === 'confirm') {
                this.getData()
            }
        }
    },
}
</script>

<style scoped>
.formDiv {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 45% !important;
}

.el-select {
    width: 100%;
}

.el-form-item__label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
}

.el-input.is-disabled .el-input__icon {
    display: none;
}

/*.formDiv .el*/
</style>
